import { ActionProduct } from '../actionTypes';

const initialState = {
  isLoading: false,
  successCreate: false,
  successUpdate: false,
  search: ''
};

const ProductReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionProduct.IS_LOADING:
      return {
        ...state,
        isLoading: action.value,
      };
    case ActionProduct.SUCCESS_CREATE:
      return {
        ...state,
        successCreate: action.value
      }
    case ActionProduct.DATA_PRODUCT:
      return{
        ...state,
        product: action.value
      }
    case ActionProduct.SUCCESS_UPDATE: 
      return {
        ...state,
        successUpdate: action.value
      };
    case ActionProduct.SEARCH:
      return {
        ...state,
        search: action.value
      }
    default:
      return state;
  }
};

export default ProductReducer;
